import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { testimonials } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-217" data-mp="3hfd1aizn98tm">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-218" data-mp="3r78zdu1qcyxu" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-219" data-mp="y30b7o0mcu">
      <div className="mx-auto max-w-5xl" data-id="element-220" data-mp="4188lmrjpar6">
        <h2 id="testimonials-title" className="text-center font-serif text-[30px] font-black leading-tight text-white sm:text-5xl" data-id="element-221" data-mp="91w68raa4pud">
          What other warehouse professionals are saying
        </h2>
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-222" data-mp="2atir0b3kvoie">
          <span className="font-serif text-4xl font-black text-gold" data-id="element-223" data-mp="2avdf1ya5bwqp">4.9/5</span>
          <Stars data-id="element-224" data-mp="2fsvnlnk949y6" />
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-225" data-mp="2fu6q7k1ynbnp">
          {testimonials.map((t, i) => <figure key={i} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-226" data-mp="1nu2p4nm955wh" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-227" data-mp="1nrzsvluiagjb">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-gold" loading="lazy" data-id="element-228" data-mp="1ivj36n7nru44" />
                <figcaption data-id="element-229" data-mp="1erbbqi9tg027">
                  <p className="font-extrabold text-ink" data-id="element-230" data-mp="2bjx0f0qxamem">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-231" data-mp="2bh12vdizlzqp">{t.role}</p>
                </figcaption>
              </div>
              <div className="mt-4" data-id="element-232" data-mp="22ip6euvfw7qc">
                <Stars data-id="element-233" data-mp="22hnoq7jx4mzn" />
              </div>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-ink" data-id="element-234" data-mp="22kjps4r2brsb">{t.quote}</blockquote>
            </figure>)}
        </div>

        <SectionCta label="I want to take control of my picking" tone="dark" data-id="element-235" data-mp="r4lahj5ak9in" />
      </div>
    </section>;
}